// extracted by mini-css-extract-plugin
module.exports = {"Buttons":"Buttons_Buttons__1VE8n","Counter":"Buttons_Counter__12x0Q","WishlistButton":"Buttons_WishlistButton__xn1tG"};